const $ = jQuery;

/**
 * Class sticky sidebar
 * 
 * Controls scroll events to determine which item is active.
 */
class StickySidebar {
    constructor() {
        this.sections    = $('.block-sticky-sidebar-content__container .block-content-section').get().reverse();
        this.nav         = $('.block-sticky-sidebar-content__nav');
        this.overlay     = $('.block-sticky-sidebar-content__overlay');
        this.listItems   = this.nav.find('.block-sticky-sidebar-content__list-item');
        this.hooks       = this.listItems.find('a');

        this.sectionOffsets = this.getSectionOffsets();

        // Set the first item to active.
        $('.block-sticky-sidebar-content__list-item:first-child')
            .addClass('.block-sticky-sidebar-content__list-item--active')

        // Add event listeners.
        window.addEventListener( 'scroll', this.handleScrollEvent.bind(this), { passive: true } );
        window.addEventListener( 'resize', this.handleResizeEvent.bind(this), { passive: true } );
        window.addEventListener( 'load', this.handleResizeEvent.bind(this) );
        this.overlay.on( 'click', this.handleOverlayClick.bind(this) );
        this.hooks.on( 'click', this.handleHookClick.bind(this) );
        this.listItems.on( 'click', this.handleListItemClick.bind(this) );
    }

    /**
     * Handle resize event
     * 
     * Fetch and set section offsets.
     * 
     * @param {Event} e Resize event.
     */
    handleResizeEvent( e ) {
        this.sectionOffsets = this.getSectionOffsets();
    }

    /**
     * Handle scroll event
     * 
     * Get the active section based on the window scroll position.
     */
    handleScrollEvent() {
        const activeSection = this.sectionOffsets.find( section => {
            return window.scrollY >= section.offsetTop && window.scrollY <= section.offsetBottom
        });

        if ( activeSection && window.lastActiveSection !== activeSection ) {
            window.lastActiveSection = activeSection;

            this.setActiveHook( activeSection );
        }
    }

    /**
     * Handle overlay click
     * 
     * @param {Event} e  Click event.
     */
    handleOverlayClick( e ) {
        this.nav.toggleClass('block-sticky-sidebar-content__nav--open');
    }

    /**
     * Handle hook click
     * 
     * @param {Event} e  Click event.
     */
    handleHookClick( e ) {
        this.nav.removeClass('block-sticky-sidebar-content__nav--open');
    }

    /**
     * Handle list item click
     *
     * Close nav menu if the first list item is clicked (the arrow)
     * 
     * @param {Event} e  Click event.
     */
    handleListItemClick( e ) {
        const target = $( e.target );

        if ( target.is('.block-sticky-sidebar-content__list-item:first-child' ) ) {
            this.nav.removeClass('block-sticky-sidebar-content__nav--open');
        }
    }

    /**
     * Get section offsets
     * 
     * @returns array
     */
    getSectionOffsets() {
        let headerHeight = getComputedStyle( document.documentElement ).getPropertyValue('--headerHeight');
            headerHeight = parseInt( headerHeight.replace('px', '') );

        return this.sections.map( section => {
            const element = $( section )

            return {
                element: section,
                offsetTop: element.offset().top - headerHeight,
                offsetBottom: element.offset().top + section.offsetHeight - headerHeight,
            }
        });
    }

    /**
     * Set active hook.
     * 
     * @param {object} section Section element & offsets.
     */
    setActiveHook( section ) {
        const targetHook = $(`a[href="#${ section.element.id }"]`);

        if ( targetHook.length ) {
            $( '.block-sticky-sidebar-content__list-item--active' )
                .trigger('blur')
                .removeClass('block-sticky-sidebar-content__list-item--active');

            targetHook.parent().addClass('block-sticky-sidebar-content__list-item--active');
        }
    }
}

new StickySidebar();